import React from 'react';
import { WebsiteDesignProps } from './types';
import { Box, Layers, Maximize } from 'lucide-react';
import { Button } from "@/components/ui/button";

const VirtualReality: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Meta Learning";

    return (
        <div className="bg-[#0b0c15] text-cyan-400 min-h-screen font-mono relative overflow-hidden">
            {/* Grid Floor */}
            <div className="absolute inset-0 pointer-events-none" style={{
                backgroundImage: 'linear-gradient(rgba(34, 211, 238, 0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(34, 211, 238, 0.2) 1px, transparent 1px)',
                backgroundSize: '40px 40px',
                transform: 'perspective(500px) rotateX(60deg) translateY(100px) scale(2)',
                opacity: 0.3
            }}></div>

            <nav className="relative z-20 p-6 flex justify-between items-center border-b border-cyan-800 bg-[#0b0c15]/80 backdrop-blur">
                <div className="flex items-center gap-2">
                    <Box className="animate-pulse" />
                    <span className="text-xl font-bold tracking-widest uppercase">{schoolName}</span>
                </div>
                <div className="flex gap-4">
                    <Button variant="outline" className="border-cyan-500 text-cyan-500 hover:bg-cyan-900/50 uppercase text-xs tracking-widest">
                        Connect Wallet
                    </Button>
                </div>
            </nav>

            <main className="container mx-auto px-8 py-20 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div>
                         <div className="inline-block border border-cyan-500/50 bg-cyan-900/20 px-4 py-1 text-xs mb-8 rounded">
                             Status: Online
                         </div>
                         <h1 className="text-6xl md:text-7xl font-bold mb-8 text-white leading-none">
                             School <br/> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500">Unbounded.</span>
                         </h1>
                         <p className="text-xl text-gray-400 mb-12 max-w-md">
                             Step inside the classroom from anywhere. Immersive labs, global classmates, infinite possibilities.
                         </p>
                         
                         <div className="flex items-center gap-6">
                             <Button className="bg-cyan-600 hover:bg-cyan-500 text-white rounded px-8 py-6 uppercase font-bold tracking-widest shadow-[0_0_20px_rgba(8,145,178,0.5)]">
                                 Enter VR Campus
                             </Button>
                         </div>
                    </div>

                    <div className="relative h-96 w-full border border-cyan-500/30 bg-black/50 rounded-lg p-4 flex items-center justify-center">
                        {/* Floating Elements */}
                        <div className="absolute top-10 left-10 w-20 h-20 border border-purple-500/50 rounded bg-purple-900/10 animate-float delay-0"></div>
                        <div className="absolute bottom-10 right-10 w-32 h-32 border border-cyan-500/50 rounded bg-cyan-900/10 animate-float delay-1000"></div>
                        
                        <div className="text-center relative z-10">
                            <Maximize size={64} className="mx-auto mb-4 text-white opacity-50" />
                            <p className="text-xs uppercase tracking-widest text-cyan-500 animate-pulse">Initializing Environment...</p>
                        </div>

                        {/* Corner Markers */}
                        <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-cyan-500"></div>
                        <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-cyan-500"></div>
                        <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-cyan-500"></div>
                        <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-cyan-500"></div>
                    </div>
                </div>

                <div className="mt-24 border-t border-cyan-900 pt-8 flex justify-between text-xs text-gray-500 uppercase tracking-widest">
                     <div>Server: US-East-1</div>
                     <div>Latency: 12ms</div>
                     <div>Users: 42,910</div>
                </div>
            </main>
        </div>
    );
};

export default VirtualReality;
